var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"variant":_vm.varient,"dismissible":"","fade":"","show":_vm.dismissCountDown},on:{"dismiss-count-down":_vm.countDownChanged}},[_c('strong',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "+_vm._s(_vm.message)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }